module.exports = __webpack_public_path__ + "img/target.51eaf938.svg";